import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, change } from 'redux-form';

import { init, clearNotificacoes, getMembrosEquipe, clearMembrosEquipe } from './ordemServicoActions';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelectForm from '../../common/form/labelAndSelectForm';
import NotificacaoSearchableSelect from './ordemServicoNotificacaoSelect';
import Grid from '../../common/layout/grid';
import Button from '../../common/form/button';

const renderTextarea = field => (
  <Grid cols={field.cols}>
    <div className="form-group form-group-sm">
      <label className="label-gt" htmlFor={field.name}>
        {field.label}
      </label>
      <textarea
        {...field.input}
        className="form-control"
        rows={field.rows || 4}
        placeholder={field.placeholder}
        style={{ resize: 'vertical' }}
      />
    </div>
  </Grid>
);

function withSelectChange(handler) {
  return props => (
    <LabelAndSelectForm
      {...props}
      input={{
        ...props.input,
        onChange: e => {
          props.input.onChange(e);
          handler(e, props);
        },
      }}
    />
  );
}

class OrdemServicoForm extends Component {
  constructor(props) {
    super(props);
    this.handleGrupoFiltroChange = this.handleGrupoFiltroChange.bind(this);
    this.handleControladorChange = this.handleControladorChange.bind(this);
    this.handleEquipeChange = this.handleEquipeChange.bind(this);
    this.GrupoFiltroSelect = withSelectChange(this.handleGrupoFiltroChange);
    this.ControladorSelect = withSelectChange(this.handleControladorChange);
    this.EquipeSelect = withSelectChange(this.handleEquipeChange);
  }

  handleGrupoFiltroChange(e) {
    this.props.change('controlador_id', '');
    this.props.change('controlador_erro_id', '');
    this.props.clearNotificacoes();
  }

  handleControladorChange(e) {
    this.props.change('controlador_erro_id', '');
  }

  handleEquipeChange(e) {
    const value = e.target.value;
    this.props.change('usuario_responsavel_id', '');
    if (value) {
      this.props.getMembrosEquipe(value);
    } else {
      this.props.clearMembrosEquipe();
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const premiumForm = true;
    const isUpdate = this.props.isUpdate === true;
    const opcoes = this.props.opcoes || {
      controladores: [],
      grupos_fisicos: [],
      equipes: [],
      usuarios: [],
    };
    const formValues = this.props.formValues || {};
    const grupoFiltro = formValues.grupo_fisico_filtro;
    const controladorId = formValues.controlador_id;
    const equipeId = formValues.equipe_id;
    const membrosEquipe = this.props.membrosEquipe || [];

    const controladoresFiltrados = grupoFiltro
      ? opcoes.controladores.filter(c => String(c.grupo_fisico_id) === String(grupoFiltro))
      : opcoes.controladores;

    const responsaveis = equipeId
      ? membrosEquipe.map(m => ({ id: m.usuario_id, nome: m.nome_usuario }))
      : opcoes.usuarios;

    const colGrupo = premiumForm ? '12 3' : '12';
    const colCtrl = premiumForm ? '12 3' : '12';
    const colNotif = premiumForm ? '12 3' : '12';
    const colEquipe = premiumForm ? '12 3' : '12';

    return (
      <form onSubmit={handleSubmit} autoComplete="off" className="simple-cad-form-premium manutencao-cad-premium os-cad-premium">
        <div className={premiumForm ? 'simple-cad-premium-container' : 'box-body'}>
          <div className={premiumForm ? 'simple-cad-premium-card' : ''}>
            {premiumForm && (
              <div className="simple-cad-premium-header">
                <h4>
                  <i className="fa fa-clipboard-list" /> Ordem de Serviço
                </h4>
                <p>Abertura e acompanhamento de manutenções corretivas, preventivas e implantações.</p>
              </div>
            )}
            <div className={premiumForm ? 'simple-cad-premium-body' : ''}>
              {isUpdate && (
                <Field
                  name="numero"
                  component={LabelAndInput}
                  readOnly
                  label="Número"
                  cols={premiumForm ? '12 3' : '12'}
                />
              )}
              <Field
                name="titulo"
                component={LabelAndInput}
                label="Título"
                cols={premiumForm ? (isUpdate ? '12 9' : '12 12') : '12'}
                placeholder="Ex.: Lâmpada queimada no cruzamento X"
              />

              <Field name="tipo" component={LabelAndSelectForm} label="Tipo" cols={premiumForm ? '12 3' : '12'}>
                <option value="CORRETIVA">Corretiva</option>
                <option value="PREVENTIVA">Preventiva</option>
                <option value="IMPLANTACAO">Implantação</option>
                <option value="RECLAMACAO">Reclamação</option>
              </Field>
              <Field
                name="prioridade"
                component={LabelAndSelectForm}
                label="Prioridade"
                cols={premiumForm ? '12 3' : '12'}
              >
                <option value="BAIXA">Baixa</option>
                <option value="MEDIA">Média</option>
                <option value="ALTA">Alta</option>
                <option value="CRITICA">Crítica</option>
              </Field>
              <Field name="status" component={LabelAndSelectForm} label="Status" cols={premiumForm ? '12 3' : '12'}>
                <option value="ABERTA">Aberta</option>
                <option value="AGUARDANDO_MATERIAL">Aguardando material</option>
                <option value="EM_ATENDIMENTO">Em atendimento</option>
                <option value="AGUARDANDO_VALIDACAO">Aguardando validação</option>
                <option value="FINALIZADA">Finalizada</option>
                <option value="CANCELADA">Cancelada</option>
              </Field>
              <Field
                name="sla_horas"
                component={LabelAndInput}
                type="number"
                label="SLA (horas)"
                cols={premiumForm ? '12 3' : '12'}
                placeholder="Opcional"
              />

              <Field name="grupo_fisico_filtro" component={this.GrupoFiltroSelect} label="Grupo Físico" cols={colGrupo}>
                <option value="">Todos</option>
                {opcoes.grupos_fisicos.map(g => (
                  <option key={g.id} value={g.id}>
                    {g.descricao}
                  </option>
                ))}
              </Field>

              <Field name="controlador_id" component={this.ControladorSelect} label="Controlador" cols={colCtrl}>
                <option value="">Nenhum</option>
                {controladoresFiltrados.map(c => (
                  <option key={c.id} value={c.id}>
                    {`Ctrl ${String(c.numero_controlador).padStart(2, '0')}${c.endereco ? ` — ${c.endereco}` : ''}`}
                  </option>
                ))}
              </Field>

              {controladorId && (
                <Field
                  name="controlador_erro_id"
                  component={NotificacaoSearchableSelect}
                  controladorId={controladorId}
                  label="Notificação"
                  cols={colNotif}
                />
              )}

              <Field name="equipe_id" component={this.EquipeSelect} label="Equipe" cols={colEquipe}>
                <option value="">Não atribuída</option>
                {opcoes.equipes.map(e => (
                  <option key={e.id} value={e.id}>
                    {e.nome}
                  </option>
                ))}
              </Field>
              <Field
                name="usuario_responsavel_id"
                component={LabelAndSelectForm}
                label="Responsável"
                cols={premiumForm ? '12 4' : '12'}
              >
                <option value="">Não atribuído</option>
                {responsaveis.map(u => (
                  <option key={u.id} value={u.id}>
                    {u.nome}
                  </option>
                ))}
              </Field>
              {equipeId && responsaveis.length === 0 && (
                <Grid cols={premiumForm ? '12 12' : '12'}>
                  <p style={{ color: '#718096', fontSize: 12, margin: '0 0 10px' }}>
                    Esta equipe não possui membros cadastrados. Adicione membros em Manutenção → Equipes.
                  </p>
                </Grid>
              )}

              {!isUpdate && (
                <Grid cols="12 12">
                  <div
                    style={{
                      display: 'flex',
                      gap: 10,
                      alignItems: 'flex-start',
                      padding: '12px 14px',
                      marginBottom: 12,
                      borderRadius: 8,
                      background: '#ebf8ff',
                      border: '1px solid #bee3f8',
                      color: '#2c5282',
                      fontSize: 13,
                      lineHeight: 1.5,
                    }}
                  >
                    <i className="fa fa-info-circle" style={{ marginTop: 2, fontSize: 16 }} />
                    <span>
                      <strong>Materiais de estoque:</strong> não são aplicados nesta etapa. Após abrir a OS, use a aba{' '}
                      <strong>Materiais</strong> ou o botão de ação na listagem para registrar os itens utilizados — a
                      saída do estoque é feita automaticamente.
                    </span>
                  </div>
                </Grid>
              )}

              <Field
                name="descricao"
                component={renderTextarea}
                label="Descrição / diagnóstico"
                cols="12 12"
                placeholder="Detalhe o problema, a solução aplicada, materiais previstos..."
              />
            </div>
          </div>
        </div>
        <div className={premiumForm ? 'simple-cad-premium-footer' : 'box-footer'}>
          <Button type="submit" className={this.props.submitClass} icon="check" label={this.props.submitLabel} />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

OrdemServicoForm = reduxForm({
  form: 'ordemServicoForm',
  destroyOnUnmount: false,
  validate: values => {
    const errors = {};
    if (!values.titulo || !String(values.titulo).trim()) {
      errors.titulo = 'Título é obrigatório.';
    }
    return errors;
  },
})(OrdemServicoForm);
const mapStateToProps = state => ({
  opcoes: state.manutencaoOS.opcoes,
  membrosEquipe: state.manutencaoOS.membrosEquipe,
  formValues: state.form.ordemServicoForm && state.form.ordemServicoForm.values,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({ init, change, clearNotificacoes, getMembrosEquipe, clearMembrosEquipe }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrdemServicoForm);
